<template>
	<div class="login-bac open-login">
		<div class="login-box">
			<!-- login模态框 -->
			<div v-show="mode != 'qq'" class="login-main">
				<!-- left -->
				<div class="login-main-left">
					<!-- 默认标题 -->
					<div class="login-main-left-title">
						<div>
							<img src="../../mycomponents/img/login/ico_logo@2x.png" alt="" /><span>{{
								$t("fastcompression")
							}}</span>
						</div>
						<p>3{{ $t("secondstostartcompression") }}</p>
					</div>
					<!-- 主要登录部分 -->
					<div class="login-main-left-body">
						<!-- 微信登录 -->
						<div class="login-main-left-weixin" v-show="mode == 'wx'">
							<div class="login-main-left-weixin-erweima">
								<webview
									ref="wx"
									id="login-main-left-weixin-erweima-iframe"
									@dom-ready="[wxLoadEnd(), webViewLoadOver('wx')]"
									src=""
								></webview>
								<div
									class="login-main-left-weixin-erweima-waitAnimation"
									:class="{
										'login-main-left-weixin-erweima-waitAnimation-ready': !isWxReady,
										'login-main-left-weixin-erweima-login-success': isWxLogin,
									}"
									@click="getNewWX"
								></div>
							</div>
							<div class="login-main-left-weixin-message">
								<div>
									<img src="../../mycomponents/img/login/sty weixin.svg" alt="" />
								</div>
								<div>
									<span>{{ $t("text017") }}</span>
								</div>
							</div>
						</div>
						<!-- 手机登录 -->
						<div class="login-main-left-phone" v-show="mode == 'phone'">
							<!-- 输入手机号 -->
							<div class="login-main-left-phone-number login-main-left-phone-div">
								<img
									:src="
										phone.phoneNumber.length > 0
											? require('../../mycomponents/img/login/-s-icon geren.svg')
											: require('../../mycomponents/img/login/-s-icon geren (2).svg')
									"
									alt=""
								/>
								<input
									type="text"
									:value="phone.phoneNumber"
									@input="phone.onChangePhoneNumber($event.target.value)"
									@blur="phone.onBlurPhone($event.target.value)"
									maxlength="11"
									:placeholder="$t('pleaseenteryourmobilephonenumber')"
								/>
							</div>
							<!-- 输入图形验证码 -->
							<div
								class="login-main-left-phone-imageCheck login-main-left-phone-div"
								v-if="phone.imageURL"
							>
								<img
									:src="
										phone.imageCode.length < 4
											? require('../../mycomponents/img/login/icon txzz1.svg')
											: require('../../mycomponents/img/login/icon txzz2.svg')
									"
									alt=""
								/>
								<input
									type="text"
									v-model="phone.imageCode"
									:placeholder="$t('text018')"
									@input="phone.onChangeImageCode($event.target.value)"
									@blur="phone.onBlurImgCode($event.target.value)"
								/>
								<div id="login-main-left-phone-imageCheck-img">
									<img :src="phone.imageURL" alt="" @click="phone.getImageCode()" />
								</div>
							</div>
							<!-- 输入验证码 -->
							<div class="login-main-left-phone-numberCheck login-main-left-phone-div">
								<img
									:src="
										phone.smsCode.length > 0
											? require('../../mycomponents/img/login/-s-icon yanzheng.svg')
											: require('../../mycomponents/img/login/-s-icon yanzheng (2).svg')
									"
									alt=""
								/>
								<input
									type="text"
									name=""
									id=""
									v-model="phone.smsCode"
									@input="phone.onChangeSmsCode($event.target.value)"
									:placeholder="$t('pleaseentersmsverificationcode')"
									@blur="phone.onBlurSms($event.target.value)"
								/>
								<div
									v-if="!phone.smsTimeout && !phone.smsLoading"
									class="login-main-left-phone-numberCheck-divbefore"
									@click="phone.sendSms()"
								>
									{{ $t("getverificationcode") }}
								</div>
								<div v-else class="login-main-left-phone-numberCheck-divafter">
									<span
										class="login-main-left-phone-numberCheck-divafter-span"
										:class="{
											'login-main-left-phone-numberCheck-divafter-span-countDown': phone.smsLoading
												? false
												: true,
										}"
									>
										{{ phone.smsLoading ? $t("load") : $t("resend") + phone.smsTimeout + "s)" }}
										<!-- 加载中... -->
									</span>
									<img
										v-if="phone.smsLoading ? true : false"
										class="login-main-left-phone-numberCheck-divafter-img"
										src="../../mycomponents/img/login/验证码加载.gif"
										alt=""
									/>
								</div>
							</div>
							<!-- 提交登录 -->
							<div class="login-main-left-phone-loginBtn login-main-left-phone-div">
								<button @click="doLogin">{{ $t("signin") }}</button>
							</div>
						</div>
					</div>
					<!-- 其他的登录方式 -->
					<div class="login-main-left-otherway">
						<div @click="mode = 'qq'">
							<img src="../../mycomponents/img/login/icon_32_qq.svg" alt="" /><span
								>QQ{{ $t("signin") }}</span
							>
						</div>
						<div @click="mode = 'phone'" :class="{loginBtnChange: mode == 'phone'}">
							<img src="../../mycomponents/img/login/icon_32_phone.svg" alt="" /><span>{{
								$t("mobilelogin")
							}}</span>
						</div>
						<!-- weixin切换按钮 -->
						<div @click="mode = 'wx'" :class="{loginBtnChange: mode == 'wx'}" v-bind="isVIP">
							<img src="../../mycomponents/img/login/icon_32_weixin.svg" alt="" /><span>{{
								$t("wechatlogin")
							}}</span>
						</div>
					</div>
				</div>
				<!-- right -->
				<div class="login-main-right">
					<div class="login-main-right-close" @click="closeLogin()"></div>
					<div class="login-main-right-main">
						<p>{{ $t("loginnow") }}</p>
						<p>{{ $t("getsixexperiencesnow") }}</p>
						<div>
							<img src="../../mycomponents/img/login/Group 678@2x.png" alt="" /><span>{{
								$t("text019")
							}}</span>
						</div>
						<div>
							<img src="../../mycomponents/img/login/Group 678@2x.png" alt="" /><span>{{
								$t("text020")
							}}</span>
						</div>
						<div>
							<img src="../../mycomponents/img/login/Group 678@2x.png" alt="" /><span>{{
								$t("text021")
							}}</span>
						</div>
						<div>
							<img src="../../mycomponents/img/login/Group 678@2x.png" alt="" /><span>{{
								$t("text022")
							}}</span>
						</div>
						<div>
							<img src="../../mycomponents/img/login/Group 678@2x.png" alt="" /><span>{{
								$t("unlimitedfilesizecompressionwill")
							}}</span>
						</div>
						<div>
							<img src="../../mycomponents/img/login/Group 678@2x.png" alt="" /><span>{{
								$t("upto90lessstorage")
							}}</span>
						</div>
					</div>
				</div>
			</div>
			<!-- 错误提示信息 -->
			<div class="login-errmessage" v-show="errmessage">
				<img
					class="login-errmessage-err"
					src="../../mycomponents/img/login/btn x.svg"
					alt=""
				/><span>{{ errmessage }}</span>
				<img
					class="login-errmessage-close"
					src="../../mycomponents/img/login/btn_x@2x(1).png"
					alt=""
					@click="clickErrMessage"
				/>
			</div>
		</div>
		<!-- qq登录弹窗 -->
		<div v-show="mode == 'qq'" class="login-qq-main">
			<!-- 点击关闭事件 -->
			<div class="login-qq-main-close" @click="mode = _prevmode"></div>
			<webview ref="qq" id="login-qq-main-iframe" @dom-ready="webViewLoadOver('qq')" src="">
			</webview>
		</div>
	</div>
</template>

<script>
import {store} from "../../plugins";
import {thirdLogin, PhoneLogin} from "../../plugins/sdk";
export default {
	data() {
		return {
			phone: new PhoneLogin(),
			isVIP: false,
			imgCodeUrl: "",
			mode: "wx",
			isWxReady: true,
			isWxLogin: false,
			errMessageTime: "",
		};
	},
	computed: {
		errmessage() {
			let errmap = {
				1: this.$t("incorrectmobilephonenumber"),
				2: this.$t("sendingverificationcode"),
				3: this.$t("text023"),
				4: this.$t("pictureverificationcoderequir"),
				5: this.$t("mobilephonenumbercannotbeempty"),
				6: this.$t("pleaseentersmsverificationcode"),
				7: this.$t("text024"),
				8: this.$t("text025"),
				9: this.$t("text026"),
			};
			return errmap[this.phone.errorCode] || "";
		},
		isFenBianLvChanged() {
			return store.isFenBianLvChangeOver;
		},
	},
	watch: {
		mode: "changeMode",
		isFenBianLvChanged(newval, oldval) {
			console.log("newval", newval);
			if (!newval) {
				let b = null;
				let a = screen.width / 1980;
				if (this.mode == "wx") {
					if (!this.$refs.wx.isLoading()) {
						console.log("wx");
						this.$refs.wx.setZoomFactor(a);
					} else {
						let _this = this;
						b = setInterval(() => {
							if (!_this.$refs.wx.isLoading()) {
								console.log("wx");
								_this.$refs.wx.setZoomFactor(a);
								clearInterval(b);
							}
						}, 500);
					}
				} else if (this.mode == "qq") {
					if (!this.$refs.qq.isLoading()) {
						console.log("qq");
						this.$refs.qq.setZoomFactor(a);
					} else {
						let _this = this;
						b = setInterval(() => {
							if (!_this.$refs.qq.isLoading()) {
								console.log("qq");
								_this.$refs.qq.setZoomFactor(a);
								clearInterval(b);
							}
						}, 500);
					}
				}
				store.isFenBianLvChangeOver = true;
			}
		},
		errmessage(newval, oldval) {
			clearTimeout(this.errMessageTime);
			if (newval) {
				this.errMessageTime = setTimeout(() => {
					this.phone.errorCode = 0;
				}, 3000);
			}
		},
	},
	methods: {
		changeMode(val, old) {
			this._prevmode = old;
			clearTimeout(this.handler);
			if (this.mode == "wx") {
				this.loadWx();
			} else if (this.mode == "qq") {
				this.loadQq();
			} else if (this.mode == "phone") {
				this._third.stop();
			}
		},
		// 点击登录按钮进行登录
		async doLogin() {
			try {
				let user = await this.phone.submit();
				this.closeLogin(user);
			} catch (ret) {
				console.error("ret:", ret);
				if (ret.code == 12007 || ret.code == 12025) {
					this.phone.onError(8);
				}
			}
		},
		wxLoadStart(e) {
			this.isWxReady = true;
		},
		wxLoadEnd(e) {
			this.isWxReady = false;
		},
		webViewLoadOver(src) {
			let a = screen.width / 1980;
			if (src == "wx") this.$refs.wx.setZoomFactor(a);
			if (src == "qq") this.$refs.qq.setZoomFactor(a);
			store.isFenBianLvChangeOver = true;
		},
		getNewWX() {
			this.wxLoadStart();
			setTimeout(this.loadWx, 500);
		},
		// 接口请求
		// 第三方登录获取二维码
		async thirdLogin() {
			this._third = await thirdLogin();
			this.$refs.wx.src = `https://api.shoujihuifu.com/wap_pay/wx_login/login.html?guid=${this._third.logintag}`;
			this.$refs.qq.src = `https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=101423511&response_type=token&scope=all&redirect_uri=http://app.xunjiepdf.com/scanlogin/qqlogin?state=${this._third.logintag}`;
			console.log("当前的微信请求地址", this.$refs.wx.src, this._third.logintag);
			// this.loading = true;
			let user = await this._third.wait();
			// console.log(user);
			this.isWxLogin = true;
			let fn = this.closeLogin;
			setTimeout(function () {
				// console.log("关闭登录");
				fn(user);
			}, 2000);
		},
		async loadWx() {
			return await this.thirdLogin();
		},
		async loadQq() {
			return await this.thirdLogin();
		},
		closeLogin(user) {
			this._third.stop();
			this.isWxLogin = false;
			var is_vip, login_type;
			// if (this.$local.userLoginData) return;
			if (user) {
				this.$app.setUserInfo(user);
				is_vip = this.$app.VIPState;
				// console.log("is_vip", is_vip);
				// console.log("user", user);
				switch (user.accounttype) {
					case 1:
						login_type = this.$t("mobilephoneloginsucceed");
						break;
					case 3:
						login_type = this.$t("wechatloginsucceed");
						break;
					case 4:
						login_type = "QQ登录成功";
						break;
				}
				// console.log(login_type);
				window.gevt(login_type, "登录事件", "None", "None", is_vip, "None");
				this.$emit("close", true);
			} else {
				this.$emit("close", false);
			}
		},
		clickErrMessage() {
			//关闭errmessage
			this.phone.errorCode = 0;
		},
	},
	mounted() {
		// console.log("获取微信二维码");
		// this.$refs.wx.src = `https://api.shoujihuifu.com/wap_pay/wx_login/login.html`;
		this.loadWx();
		window.gevt("登录页面", "视图事件", "登录页面", "None", "未登录", "None");
	},
};
</script>

<style>
.login-bac {
	position: fixed;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	z-index: 9998;
	background: rgba(0, 0, 0, 0.4);
}
/* 包含登录div和错误信息提示 */
.login-box {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 999;
}
.login-main {
	/* position: absolute;
	top: 22%;
	left: 19.92%; */
	height: 420rem;
	width: 711rem;
	z-index: 9999;
	/* display: none; */
	display: flex;
	background: white;
	border-radius: 10rem;
	border-right: 1px solid #4baaf2;
}

.login-main-left {
	display: inline-block;
	position: relative;
	vertical-align: middle;
	width: 328rem;
	height: 420rem;
	background: #ffffff;
	opacity: 1;
	border-radius: 8rem 0rem 0rem 8rem;
	box-sizing: border-box;
}
.login-main-right {
	display: inline-block;
	vertical-align: middle;
	width: 383rem;
	/* flex: 1; */
	height: 420rem;
	/* background: rgba(0, 0, 0, 0.4); */
	background-image: url("./../../mycomponents/img/login/bg_dengl@2x.png");
	background-size: cover;
	border-radius: 0rem 8rem 8rem 0rem;
	opacity: 1;
	box-sizing: border-box;
}

/* left */
/* title */
.login-main-left-title {
	margin-top: 43rem;
	text-align: center;
}
.login-main-left-title div::after {
	content: "";
	display: inline-block;
	height: 100%;
	vertical-align: middle;
}
.login-main-left-title div {
	height: 29rem;
	margin-bottom: 8rem;
}
.login-main-left-title div img {
	height: 23rem;
	width: 29rem;
	display: inline-block;
	vertical-align: middle;
	margin-right: 8rem;
}
.login-main-left-title div span {
	vertical-align: middle;
	font-size: 20rem;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #1b212e;
	opacity: 1;
}
.login-main-left-title p {
	font-size: 14rem;
	font-family: MicrosoftYaHei;
	color: #444444;
	opacity: 1;
}
/* 主要登录部分 */
.login-main-left-body {
	height: 240rem;
	width: 100%;
}
.login-main-left-body::after {
	content: "";
	display: inline-block;
	height: 100%;
	vertical-align: middle;
}
/* weixin */
.login-main-left-weixin {
	margin-top: 24rem;
	text-align: center;
}
.login-main-left-weixin-erweima {
	margin-bottom: 8rem;
	margin-left: auto;
	position: relative;
	margin-right: auto;
	height: 144rem;
	width: 144rem;
}
.login-main-left-weixin-erweima-waitAnimation {
	position: absolute;
	width: 144rem;
	height: 144rem;
	box-sizing: border-box;
	/* background: rgba(0, 0, 0, 0); */
	background-repeat: no-repeat;
	background-position: center center;
	background-image: url("../../mycomponents/img/login/微信二维码等待.gif");
	opacity: 1;
	transition: opacity 0.5s;
	background-size: 60rem, 60rem;
	cursor: pointer;
	z-index: 99;
	left: 0;
	top: 0;
}
.login-main-left-weixin-erweima-waitAnimation-ready {
	/* background: rgba(0, 0, 0, 0); */
	opacity: 0;
}
.login-main-left-weixin-erweima-login-success {
	opacity: 1;
	background-size: 40rem, 40rem;
	background-image: url("../../mycomponents/img/login/icon_20_xuanzhong.svg");
}
#login-main-left-weixin-erweima-iframe {
	display: inline-flex;
	height: 144rem;
	width: 144rem;
}
.login-main-left-weixin-message {
	height: 25rem;
	display: flex;
	justify-content: center;
}
.login-main-left-weixin-message div {
	display: inline-block;
	align-items: center;
	justify-content: center;
}
.login-main-left-weixin-message div:first-child {
	display: inline-block;
	vertical-align: middle;
}
.login-main-left-weixin-message::after {
	content: "";
	height: 100%;
	display: inline-block;
	vertical-align: middle;
}
.login-main-left-weixin-message img {
	height: 16rem;
	width: 16rem;
	vertical-align: middle;
	display: inline-block;
	margin-right: 4rem;
}
.login-main-left-weixin-message span {
	vertical-align: middle;
	font-size: 12rem;
	font-family: MicrosoftYaHei;
	color: #444444;
	opacity: 1;
}
/* otherway */
.login-main-left-otherway {
	position: absolute;
	bottom: 40rem;
	height: 40rem;
	box-sizing: border-box;
	padding: 0 32rem;
}
.login-main-left-otherway div {
	display: inline-block;
	width: 117rem;
	height: 40rem;
	background: rgba(242, 242, 242, 1);
	opacity: 1;
	border-radius: 20rem;
	box-sizing: border-box;
	padding-left: 4rem;
	cursor: pointer;
}
.login-main-left-otherway div:hover {
	background: rgba(246, 245, 245, 1);
}
.login-main-left-otherway div:active {
	background: rgba(232, 231, 231, 1);
}
.login-main-left-otherway div::after {
	height: 100%;
	content: "";
	vertical-align: middle;
	display: inline-block;
}
.login-main-left-otherway div img {
	width: 32rem;
	height: 32rem;
	display: inline-block;
	vertical-align: middle;
	margin-right: 8rem;
}
.login-main-left-otherway div span {
	font-size: 14rem;
	font-family: MicrosoftYaHei;
	vertical-align: middle;
	display: inline-block;
	color: #999999;
	opacity: 1;
}
.login-main-left-otherway div:nth-of-type(1) {
	margin-right: 30rem;
}
/* right */
.login-main-right-close {
	margin-left: 351rem;
	height: 40rem;
	width: 24rem;
	background-size: cover;
	cursor: pointer;
	background-image: url("../../mycomponents/img/login/icon_syt_gb01@2x.png");
}

.login-main-right-main {
	padding-left: 43rem;
}
.login-main-right-main p:nth-of-type(1) {
	font-size: 12rem;
	font-family: MicrosoftYaHei;
	color: #ffffff;
	opacity: 1;
	margin-bottom: 4rem;
}
.login-main-right-main p:nth-of-type(2) {
	font-size: 24rem;
	font-family: MicrosoftYaHei-Bold;
	color: #ffffff;
	opacity: 1;
	margin-bottom: 32rem;
}
.login-main-right-main div {
	height: 20rem;
	margin-bottom: 24rem;
}
.login-main-right-main div::after {
	height: 100%;
	content: "";
	vertical-align: middle;
	display: inline-block;
}
.login-main-right-main div img {
	display: inline-block;
	vertical-align: middle;
	margin-right: 9rem;
	height: 17rem;
	width: 17rem;
}
.login-main-right-main div span {
	vertical-align: middle;
	font-size: 14rem;
	font-family: Microsoft YaHei;
	color: #ffffff;
	opacity: 1;
}

/* qq 弹窗 */
.login-qq-main {
	width: 710rem;
	height: 420rem;
	position: absolute;
	top: 22%;
	left: 19.92%;
	/* background-color: aquamarine; */
}

.login-qq-main-close {
	position: absolute;
	top: 0;
	right: 11rem;
	height: 40rem;
	width: 24rem;
	background-image: url("../../mycomponents/img/login/icon_syt_gb01@2x (1).png");
	background-size: cover;
	cursor: pointer;
}
#login-qq-main-iframe {
	width: 100%;
	height: 100%;
	display: inline-flex;
}
/* 手机登录 */
.login-main-left-phone {
	display: inline-block;
	vertical-align: middle;
	/* text-align: center; */
	width: 100%;
	overflow: hidden;
}
.login-main-left-phone-div {
	width: 263rem;
	height: 40rem;
	margin-left: auto;
	margin-right: auto;
	text-align: center;
	margin-bottom: 16rem;
	box-sizing: border-box;
	position: relative;
}
.login-main-left-phone div input[type="text"] {
	background: #ffffff;
	border: 1rem solid #eeeeee;
	opacity: 1;
	border-radius: 4rem;
	height: 100%;
	box-sizing: border-box;
	padding-left: 50rem;
	padding-top: 13rem;
	padding-bottom: 13rem;
	outline: none;
	font-size: 14rem;
	font-family: Source Han Sans CN;
	font-weight: 300;
}
.login-main-left-phone-div img {
	display: block;
	position: absolute;
	top: 10rem;
	left: 10rem;
	width: 20rem;
	height: 20rem;
	padding-right: 10rem;
	border-right: 1rem solid #eeeeee;
}
/* 输入手机号 */
.login-main-left-phone-number input {
	width: 100%;
	height: 100%;
}
/* 输入图形验证码 */
.login-main-left-phone-imageCheck::after {
	content: "";
	display: inline-block;
	height: 100%;
	vertical-align: middle;
}
.login-main-left-phone-imageCheck input {
	width: 163rem;
	margin-right: 10rem;
	vertical-align: middle;
	display: inline-block;
}
.login-main-left-phone-imageCheck div {
	vertical-align: middle;
	display: inline-block;
	width: 90rem;
	height: 40rem;
	box-sizing: border-box;
	/* background: #eeeeee; */
	opacity: 1;
	border-radius: 4rem;
	overflow: hidden;
	/* background-size: cover; */
}
.login-main-left-phone-imageCheck div img {
	height: 100%;
	width: 100%;
	display: block;
	position: relative;
	top: 0;
	left: 0;
	border: none;
	padding: 0;
}
/* 输入验证码 */
.login-main-left-phone-numberCheck::after {
	content: "";
	display: inline-block;
	height: 100%;
	vertical-align: middle;
}
.login-main-left-phone-numberCheck input {
	width: 163rem;
	margin-right: 10rem;
	vertical-align: middle;
	display: inline-block;
}
.login-main-left-phone-numberCheck div {
	vertical-align: middle;
	display: inline-block;
	width: 90rem;
	height: 40rem;
	box-sizing: border-box;
	background: #ffffff;
	cursor: pointer;
	opacity: 1;
	border-radius: 4rem;
	text-align: center;
	line-height: 40rem;
}
.login-main-left-phone-numberCheck-divbefore {
	border: 1rem solid #0479f6;
	font-size: 14rem;
	font-family: Source Han Sans CN;
	font-weight: 300;
	color: #0479f6;
}
.login-main-left-phone-numberCheck-divafter {
	border: 1rem solid #dddddd;
}
.login-main-left-phone-numberCheck-divafter::after {
	content: "";
	height: 40rem;
	display: inline-block;
	vertical-align: middle;
}
.login-main-left-phone-numberCheck-divafter-span {
	font-size: 12rem;
	font-family: Source Han Sans CN;
	font-weight: 300;
	color: #999999;
	display: inline-block;
	vertical-align: middle;
	margin-right: 7rem;
	margin-left: 12rem;
}
.login-main-left-phone-numberCheck-divafter-span-countDown {
	margin-left: auto !important;
	margin-right: auto !important;
}
.login-main-left-phone-numberCheck-divafter-img {
	position: relative !important;
	top: 0 !important;
	left: 0 !important;
	border: none !important;
	height: 12rem !important;
	width: 12rem !important;
	display: inline-block !important;
	vertical-align: middle !important;
}
/* 提交登录 */
.login-main-left-phone-loginBtn button {
	margin-top: 5rem;
	width: 263rem;
	height: 40rem;
	background: #006de0;
	opacity: 1;
	border: none;
	border-radius: 4rem;
	box-sizing: border-box;
	font-size: 14rem;
	font-family: Source Han Sans CN;
	font-weight: 300;
	color: #ffffff;
	cursor: pointer;
}
.login-main-left-phone-loginBtn button:hover {
	background: #1081f8;
}
.login-main-left-phone-loginBtn button:active {
	background: #0064ce;
}
/* 错误信息 */
.login-errmessage {
	/* width: 300rem; */
	height: 37rem;
	position: absolute;
	right: 0;
	top: 436rem;
	border-radius: 10rem;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	background: white;
	color: rgb(147, 148, 151);
}
.login-errmessage-err {
	height: 60%;
	margin-right: 10rem;
	margin-left: 15rem;
}
.login-errmessage-close {
	cursor: pointer;
	height: 52% !important;
	margin-left: 15rem;
	margin-right: 15rem;
}
.login-errmessage span {
	padding: 1rem 0 0 0;
	margin: 0;
	display: inline-block;
	height: 20rem;
	font-size: 12rem;
	transform: translateY(2rem);
}
/* js */
.open-login {
	display: block !important;
}
.loginBtnChange {
	display: none !important;
}
</style>
